import { render } from "./whatsapp-followup-templates.vue?vue&type=template&id=ba913c78"
import script from "./whatsapp-followup-templates.vue?vue&type=script&lang=js"
export * from "./whatsapp-followup-templates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__